import { gql } from '@apollo/client';

export const deleteDeviceQuery = gql`
  mutation DeleteDevice($input: DeleteDeviceInput!) {
    deleteDevice(input: $input) {
      statusMessage
    }
  }
`;
